import { render, staticRenderFns } from "./EditDocLabPARA.vue?vue&type=template&id=43c4fe74&scoped=true"
import script from "./EditDocLabPARA.vue?vue&type=script&lang=js"
export * from "./EditDocLabPARA.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43c4fe74",
  null
  
)

export default component.exports